export default {
  field: {
    label: 'Momskategori',
    placeholder: 'Ingen momskategori',
    unlinked_hint:
      'Uden en momskategori bruger et produkt momskategorien fra sin menukategori eller restaurantens standardsats.',
    default_hint: 'Gemmes den uden, får den menuens standardmomskategori.',
  },
  empty: {
    hint: 'Ingen momskategorier endnu – tilføj en nedenfor.',
    read_only_hint: 'Der er endnu ikke oprettet nogen momskategorier.',
  },
  option: {
    varies_by_channel: '(varierer efter kanal)',
  },
  load_error: 'Momskategorierne kunne ikke indlæses – tilknytning og fjernelse er deaktiveret, indtil de er indlæst.',
  create: {
    name_placeholder: 'Navn på ny kategori',
    rate_placeholder: 'Sats %',
    button: 'Tilføj skattekategori',
  },
  toasts: {
    create_error: 'Skattekategorien kunne ikke oprettes.',
  },
};
